<template >
	<div>

	</div>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
	name: 'BaseErors',
	props: ["message"],
	data() {
		return {

		}
	},
	computed: {
		...mapGetters({
			errors: 'errors',
		}),
	},
	watch: {
		errors() {
			if (this.errors.length != 0) {
				this.$bvToast.toast(this.errors[this.errors.length-1].hasOwnProperty("text") ? this.errors[this.errors.length-1].text : "Неизвестная проблема", {
					title: this.errors[this.errors.length-1].hasOwnProperty("title") ? this.errors[this.errors.length-1].title : 'Произошла ошибка',
					variant: this.errors[this.errors.length-1].hasOwnProperty("variant") ? this.errors[this.errors.length-1].variant : "danger",
					solid: true
				})
			}
		}
	}
}
</script>


// WEBPACK FOOTER //
// src/components/views/Shared/BaseErrors.vue